import { createSlice } from "@reduxjs/toolkit";
import { feedBackReply, getFeedbacks } from "../actions/feedbacks";

const states = {
  data: null,
  loading: false,
  error: false,
  pagination: {
    current_page: 1,
    total_pages: 1,
  },
};

export const feedbacks = createSlice({
  initialState: states,
  feedbackReplyLoading: false,
  name: "feedbacks",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeedbacks.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getFeedbacks.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.data = action.payload.data?.data;
      state.pagination = {
        current_page: action.payload.data?.data?.current_page,
        total_pages: action.payload.data?.data?.last_page,
      };
    });
    builder.addCase(getFeedbacks.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });

    // FEEDBACK REPLY
    builder.addCase(feedBackReply.pending, (state, action) => {
      state.feedbackReplyLoading = true
    })

    builder.addCase(feedBackReply.fulfilled, (state, action) => {
      state.feedbackReplyLoading = false
    })

    builder.addCase(feedBackReply.rejected, (state, action) => {
      state.feedbackReplyLoading = false
    })

  },
});

export default feedbacks.reducer;
